var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioButtonPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3920_141012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 1.66406C5.4013 1.66406 1.66797 5.3974 1.66797 9.9974C1.66797 14.5974 5.4013 18.3307 10.0013 18.3307C14.6013 18.3307 18.3346 14.5974 18.3346 9.9974C18.3346 5.3974 14.6013 1.66406 10.0013 1.66406ZM10.0013 16.6641C6.31797 16.6641 3.33464 13.6807 3.33464 9.9974C3.33464 6.31406 6.31797 3.33073 10.0013 3.33073C13.6846 3.33073 16.668 6.31406 16.668 9.9974C16.668 13.6807 13.6846 16.6641 10.0013 16.6641Z",
    fill: "#44546F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3920_141012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioButtonPending);
export default __webpack_public_path__ + "static/media/radio_button_pending.b05272ee016f7b04309b4339ee97697c.svg";
export { ForwardRef as ReactComponent };